// extracted by mini-css-extract-plugin
module.exports = {"textDanger":"Lazada_textDanger__a2eRU","textBold":"Lazada_textBold__3OUpt","textSuccess":"Lazada_textSuccess__1cghs"};